module.exports = __webpack_public_path__ + "static/media/RP-68.b5308737.pdf";